import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import passwordValidator from 'password-validator';
import {Actions as CREATEACCOUNTACTIONS} from '../../store/actions/createAccountActions';
import {Actions as LOGINACTIONS} from '../../store/actions/authenticationActions';
import * as yup from 'yup';
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { NotificationManager } from "react-notifications";
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';

import BuddyFace from '../../assets/images/buddy-face.png';
import Select from 'react-select';
import Creatable from "react-select/creatable";
import { ALLOWED_HANDOFF_ORIGINS, appUrl } from "../../utils/appHandoff";

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
.is().min(8)                                    // Minimum length 8
.is().max(100)                                  // Maximum length 100
.has().uppercase()                              // Must have uppercase letters
.has().lowercase()                              // Must have lowercase letters
.has().digits(1)                                // Must have at least 1 digits
.has().not().spaces()                           // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values

let emailSchema = yup.object().shape({
  email: yup.string().required().email(),
});

const payrollSofwareOptions = {
  "UK": [
    "BrightPay",
    "Employment Hero",
    "Moneysoft: Payroll Manager",
    "Iris",
    "Sage",
    "Xero",
    "Quickbooks",
    "FreeAgent",
    "Other"
  ],
  "MT": [
      "Shireburn Indigo Payroll",
      "Dakar",
      "Salaroo",
      "Excel",
      "Talexio",
      "DataByte Payroll",
      "Other"
  ]
}
const noOfEmployeesOptions = {
  MT: [
      { value: '1-5', label: '1-5 Employees' },
      { value: '6-10', label: '6-10 Employees' },
      { value: '11-20', label: '11-20 Employees' },
      { value: '21-40', label: '21-40 Employees' },
      { value: '41-80', label: '41-80 Employees' },
      { value: '81-200', label: '81-200 Employees' },
      { value: '200+', label: '200+ Employees' }
      ],
  UK: [
        { value: '1-25', label: '1-25 Employees' },
        { value: '26-50', label: '26-50 Employees' },
        { value: '51-100', label: '51-100 Employees' },
        { value: '101-250', label: '101-250 Employees' },
        { value: '251-500', label: '251-500 Employees' },
        { value: '501-1000', label: '501-1000 Employees' },
        { value: '1001-10000', label: '1,001-10,000 Employees' },
        { value: '10001+', label: '10,000+ Employees' }
  ]
}

const noOfPayrollsOptions = [
    { value: '1-10', label: '1-10 Payrolls' },
    { value: '11-50', label: '11-50 Payrolls' },
    { value: '51-100', label: '51-100 Payrolls' },
    { value: '101-250', label: '101-250 Payrolls' },
    { value: '251-1000', label: '251-1000 Payrolls' },
    { value: '1,001+', label: '1,000+ Payrolls' }
]

const whatBestDescribesYouOptions = [
  { label: "Accountant in Practice", value: "Accountant in Practice", isPartner:true},
  { label: "Bookkeeper in Practice", value: "Bookkeeper in Practice", isPartner:true},
  { label: "Payroller in an Accounting Firm", value: "Payroller in an Accounting Firm", isPartner:true},
  { label: "Payroll Bureau Manager", value: "Payroll Bureau Manager", isPartner:true},
  { label: "In-House Payroll/HR", value: "In-House Payroll/HR", isPartner: false},
  { label: "Business Owner", value: "Business Owner", isPartner: false},
]

function RegistrationForm({
  createAccount,
  updateUserDetails,
  processing,
  logout,
  jurisdiction,
  partner,
  unknownPartner,
  list,
  leadOnly,
  leadCtaText,

  error,
  creatingAccount,
  userCreated,
  userUpdated,
  acLeadCreated,
  demoAccountCreated,
  savedLead,
  profile,
  createHandoffCode,
  saveLead,
  savingLead,
}) {
  const redirectWithHandoff = async (portal, baseUrl) => {
    try {
      // Only allow redirects to trusted Buddy origins to prevent open-redirect / XSS
      // via an attacker-controlled baseUrl (e.g. a javascript: scheme or foreign host).
      const target = new URL(`${baseUrl}/auth/handoff`, window.location.origin);
      if (!ALLOWED_HANDOFF_ORIGINS.includes(target.origin)) {
        throw new Error("Untrusted handoff destination");
      }

      const code = await createHandoffCode(portal);
      if (!code) {
        throw new Error("Missing handoff code");
      }
      target.searchParams.set("code", code);
      window.location.href = target.toString();
    } catch (error) {
      NotificationManager.error("Unable to start secure handoff. Please try again.", "Error");
    }
  };

  const hasPrefilledEmailParam = Boolean(new URLSearchParams(window.location.search).get('email'));
  const isLeadOnly = leadOnly ?? (jurisdiction === "UK");
  const shouldUseLeadForm = isLeadOnly && !hasPrefilledEmailParam;

  useEffect(() => {
    // load initial data required for anywhere
    if (!shouldUseLeadForm && !creatingAccount && userCreated && userUpdated && acLeadCreated && demoAccountCreated){
      // redirect to app dashboard
      window.location.href = appUrl()
    }
  },[creatingAccount, shouldUseLeadForm]);

  const [errorText, setErrorText] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [leadSubmitted, setLeadSubmitted] = useState(false);

  const [data, setData] = useState({
    noOfEmployees: null,
    name: profile?.givenName ?? "",
    surname: profile?.familyName ?? "",
    phone: "",
    organisation: profile?.organisation ?? "",
    email: profile?.email ?? "",
    password: "",
    jurisdiction: jurisdiction ?? "MT",
    signupAnyway: profile?.email ?? false,
    whatBestDescribesYou: null,
  });

            /*<div>
              <label htmlFor="name" className="sr-only">
                First Name
              </label>
              <div className="rounded-md shadow-sm">
                <input name="name" id="name" placeholder="First name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="surname" className="sr-only">
                Last Name
              </label>
              <div className="rounded-md shadow-sm">
                <input name="surname" id="surname" placeholder="Last name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="phone" className="sr-only">
                Phone
              </label>
              <div className="rounded-md shadow-sm">
                <input name="phone" id="phone" placeholder="Phone" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            */


  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    })
  }

  const isPartner = partner || whatBestDescribesYouOptions.filter(o => o.isPartner && o.label === data.whatBestDescribesYou?.label).length > 0

  const createDemoAccountSubmit = (e) => {
    emailSchema.isValid({
      email: data.email
    }).then(function(valid) {
      e.preventDefault();
      if(!valid) {
        setErrorText("Invalid email format")
        setIsEmailValid(false)
        return
      }

      if (isPartner){
        // check that the user has selected a payroll software, no of employees and no of payrolls
          if (!data.noOfEmployees || !data.noOfPayrolls || !data.payrollSoftware){
              setErrorText("Please select your existing Payroll Software, No of Employees and No of Payrolls.")
              return;
          }
      } else {
        if (!data.noOfEmployees){
          setErrorText("Please select the number of employees")
          return;
        }
      }

      setErrorText(null)

      console.log('dataToSubmit',data)
      const normalizedData = {
        ...data,
        noOfEmployees: data.noOfEmployees?.value ?? data.noOfEmployees,
        noOfPayrolls: data.noOfPayrolls?.value,
        payrollSoftware: data.payrollSoftware?.map(i => i.value)?.join(","),
        partner: isPartner,
      };

      if (shouldUseLeadForm) {
        saveLead({
          ...normalizedData,
          list,
        })
        setLeadSubmitted(true);
        return;
      }

      createAccount(normalizedData)
    })
  }

  const updateUserSubmit = (e) => {
    e.preventDefault();
    updateUserDetails(data)
  }

  if (!shouldUseLeadForm && creatingAccount){

    let stepDescription = "We're currently creating your account"

    if (userCreated){
      stepDescription = <>
        <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        We're creating your Demo Account
      </>
    }

    if (demoAccountCreated){
      stepDescription = "Your Demo account is nearly ready, we just need to save your details"
    }

    if (profile && !profile.isPreloaded && ((profile.givenName && profile.givenName !== "_") || (profile.name && profile.name !== "_"))){

      return (
        <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
          <div className="px-4 py-8 sm:px-10">

            <div className="mt-6">

              <div>
                <img style={{float:"left", marginRight: 5}} className="h-8 w-auto sm:h-10" src={BuddyFace} alt="Buddy HR Payroll Software Logo"/>
                <p className="text-sm leading-5 font-medium text-gray-700">
                  {profile.givenName || profile.name}, you will be redirected to your Demo Account once it is created.
                </p>
              </div>


            </div>
          </div>
          <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
            <p className="text-xs leading-5 text-gray-500">
              {stepDescription}
            </p>
          </div>
        </div>
      )
    }

    return (

      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">

          <div className="mt-6">
            <form onSubmit={updateUserSubmit} className="space-y-6">


              <div>
                <img style={{float:"left", marginRight: 5}} className="h-8 w-auto sm:h-10" src={BuddyFace} alt="Buddy HR Payroll Software Logo"/>
                <h2>Hi I'm Buddy, your new payroll companion. Could you tell me more about yourself?</h2>
              </div>

              <div>
                <label htmlFor="name" className="sr-only">
                  Name
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.name} onChange={handleChange} name="name" id="name" placeholder="Name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>

              <div>
                <label htmlFor="surname" className="sr-only">
                  Surname
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.surname} onChange={handleChange} name="surname" id="surname" placeholder="Surname" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>

              <div>
                <label htmlFor="phone" className="sr-only">
                  Phone
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.phone} onChange={handleChange} name="phone" id="surname" placeholder="Phone" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>

              {/*
                  passwordValidation && passwordValidation.length > 0 && passwordValidation[0] != "notEqual" &&
                  <div className="col-xs-12 alert-danger alert">
                    <h5 style={{
                      textAlign: "left",

                    }}>Your password must have at least.</h5>
                    <ul style={{
                listStyle: "disc",
                paddingLeft: "20px",
                textAlign: "left",
                    }}>
                      <li>8 characters long</li>
              <li>1 uppercase &amp; 1 lowercase character</li>
              <li>1 number</li>
                    </ul>
                  </div>
              */}

              <div>
                <span className="block w-full rounded-md shadow-sm">
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Save and Proceed to DEMO
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">
            {stepDescription}
          </p>
        </div>
      </div>
    )
  }



  if (!shouldUseLeadForm && profile && profile.email && !profile.isPreloaded){
    return(
      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">

          { profile.isHR > 0 &&
              <div>
                <span className="block w-full rounded-md shadow-sm">
                  <a
                    href={appUrl()}
                    onClick={(event) => {
                      event.preventDefault();
                      redirectWithHandoff("app", appUrl());
                    }}
                    className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
                  >
                    Go to Payroll Portal
                  </a>
                </span>
              </div>
          }

          { profile.isEmployee > 0 &&
              <div className="mt-6">
                <span className="block w-full rounded-md shadow-sm">
                  <a
                    href={appUrl("/employee")}
                    onClick={(event) => {
                      event.preventDefault();
                      redirectWithHandoff("employee", appUrl("/employee"));
                    }}
                    className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
                  >
                    Go to Employee Portal
                  </a>
                </span>
              </div>
          }

          <div className="mt-6 flex items-center justify-between">
              <div className="text-sm leading-5 text-center" style={{width: "100%"}}>
                Not {profile.givenName || profile.name}?
                <a
                  onClick={(e) => {
                    e.preventDefault();
                      e.stopPropagation();
                      logout()
                  }} href="#"
                  className="ml-1 pl-2 font-medium text-orange-600 hover:text-orange-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                  Log out

                  {
                    processing &&
                    <span className="ml-4">
                      <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                  }
                </a>
              </div>
            </div>



          { profile.isHR == 0 &&

            <div className="mt-6">

              <div className="inset-0 flex items-center mb-6">
                <div className="w-full border-t border-gray-200"></div>
              </div>

              <form onSubmit={createDemoAccountSubmit} className="space-y-6">
                <div>
                  <label htmlFor="organisation" className="sr-only">
                    Organisation122
                  </label>
                  <div className="rounded-md shadow-sm">
                    <input value={data['organisation']} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                  </div>
                </div>

                { unknownPartner &&
                    <div>
                        <label htmlFor="whatBestDescribesYou" className="sr-only">
                          What Best Describes you?
                        </label>
                        <div className="rounded-md shadow-sm">
                          <select onChange={handleChange} name="whatBestDescribesYou" id="whatBestDescribesYou" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                            {
                              whatBestDescribesYouOptions.map(option => (
                                <option value={option.label}>{option.label}</option>
                              ))
                            }
                          </select>
                        </div>
                      </div>
                }

                {
                  isPartner ?
                    <>
                      <div>
                        <label htmlFor="noOfEmployees" className="sr-only">
                          No of Payrolls
                        </label>
                        <div className="rounded-md shadow-sm">
                          <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                            <option value="1-10">1-10 Payrolls</option>
                            <option value="11-20">11-50 Payrolls</option>
                            <option value="21-40">50-100 Payrolls</option>
                            <option value="81-200">100-250 Payrolls</option>
                            <option value="81-200">250-1000 Payrolls</option>
                            <option value="200+">1,000+ Payrolls</option>
                          </select>
                        </div>
                      </div>

                      <div>
                        <label htmlFor="noOfEmployees" className="sr-only">
                          No of Employees
                        </label>
                        <div className="rounded-md shadow-sm">
                          <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                            <option value="1-5">1-5 Employees</option>
                            <option value="6-10">6-10 Employees</option>
                            <option value="11-20">11-20 Employees</option>
                            <option value="21-40">21-40 Employees</option>
                            <option value="41-80">41-80 Employees</option>
                            <option value="81-200">81-200 Employees</option>
                            <option value="200+">200+ Employees</option>
                          </select>
                        </div>
                      </div>
                    </>
                      :
                      <div>
                        <label htmlFor="noOfEmployees" className="sr-only">
                          No of Employees
                        </label>
                        <div className="rounded-md shadow-sm">
                          <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                            <option value="1-5">1-5 Employees</option>
                            <option value="6-10">6-10 Employees</option>
                            <option value="11-20">11-20 Employees</option>
                            <option value="21-40">21-40 Employees</option>
                            <option value="41-80">41-80 Employees</option>
                            <option value="81-200">81-200 Employees</option>
                            <option value="200+">200+ Employees</option>
                          </select>
                        </div>
                      </div>
                }

                <div>
                  <span className="block w-full rounded-md shadow-sm">
                    <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                      Create a FREE DEMO Account
                    </button>
                  </span>
                </div>
              </form>
            </div>
          }

        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
        </div>
      </div>
    )
  }

  if (shouldUseLeadForm && (savedLead || leadSubmitted)){
    return (
      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">
          <h2 className="text-xl font-semibold text-gray-900">
            Thanks — your Buddy demo is on its way
          </h2>
          <p className="mt-3 text-sm text-gray-600">
            One of our payroll specialists will review your details and get in touch shortly to walk you through the best setup for your needs.
          </p>

          <div className="mt-6">
            <p className="text-sm font-semibold text-gray-900">We’ll focus on:</p>
            <ul className="mt-3 list-disc pl-5 text-sm text-gray-600 space-y-2">
              <li>Understanding your current payroll process</li>
              <li>Highlighting where Buddy can simplify or automate things</li>
              <li>Recommending the right configuration — without overcomplicating or overselling</li>
            </ul>
          </div>

          <div className="mt-6 rounded-md bg-gray-50 p-4">
            <p className="text-sm font-semibold text-gray-900">Expectation setting</p>
            <p className="mt-2 text-sm text-gray-600">Most demos are scheduled within one working day.</p>
          </div>

          <div className="mt-6">
            <p className="text-sm font-semibold text-gray-900">What happens next</p>
            <ul className="mt-3 list-disc pl-5 text-sm text-gray-600 space-y-2">
              <li>A payroll specialist reviews your details</li>
              <li>We tailor the demo to your setup and goals</li>
              <li>You get clear answers, not a generic sales pitch</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              No obligation. No pressure. Just a clear view of how Buddy works in practice.
            </p>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">
            By signing up, you agree to our{" "}
            <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>,{" "}
            <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and{" "}
            <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.
          </p>
        </div>
      </div>
    )
  }

  return (

    <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
      <div className="px-4 py-8 sm:px-10">
        {/*<div>
          <p className="text-sm leading-5 font-medium text-gray-700">
            Sign in with
          </p>

          <div className="mt-1 grid grid-cols-3 gap-3">
            <div>
              <span className="w-full inline-flex rounded-md shadow-sm">
                <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with Facebook">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" />
                  </svg>
                </button>
              </span>
            </div>

            <div>
              <span className="w-full inline-flex rounded-md shadow-sm">
                <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with Twitter">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </button>
              </span>
            </div>

            <div>
              <span className="w-full inline-flex rounded-md shadow-sm">
                <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with GitHub">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                  </svg>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-6 relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm leading-5">
            <span className="px-2 bg-white text-gray-500">
              Or
            </span>
          </div>
        </div>*/}

        <div className="mt-6">

          {(error || errorText) &&
            <div className="rounded-md bg-red-50 p-4 mb-6">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm leading-5 font-medium text-red-800">
                    {errorText ?? error}
                  </h3>

                  {error == "Buddy is currently not available in your country" &&

                    <button type="submit" className="w-full mt-2 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
                      onClick={(e) => {
                        setData({
                            ...data,
                            signupAnyway: true
                        })
                        createDemoAccountSubmit(e)
                      }}
                    >
                      Proceed with a {data.jurisdiction} Account
                    </button>
                  }
                </div>
              </div>
            </div>

          }

          <form onSubmit={createDemoAccountSubmit} className="space-y-6">
            {shouldUseLeadForm &&
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-1">
                  <label htmlFor="name" className="sr-only">
                    Name
                  </label>
                  <div className="rounded-md shadow-sm">
                    <input value={data.name} onChange={handleChange} name="name" id="name" placeholder="Name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                  </div>
                </div>

                <div className="col-span-1">
                  <label htmlFor="surname" className="sr-only">
                    Surname
                  </label>
                  <div className="rounded-md shadow-sm">
                    <input value={data.surname} onChange={handleChange} name="surname" id="surname" placeholder="Surname" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                  </div>
                </div>
              </div>
            }

            {shouldUseLeadForm &&
              <div>
                <label htmlFor="phone" className="sr-only">
                  Phone
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.phone} onChange={handleChange} name="phone" id="phone" placeholder="Phone" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>
            }

            <div>
              <label htmlFor="organisation" className="sr-only">
                Organisation
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data.organisation} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>


            { unknownPartner &&
                <div>
                    <label htmlFor="whatBestDescribesYou" className="sr-only">
                      What Best Describes you?
                    </label>


                    <Select
			          options={
                        whatBestDescribesYouOptions
                      }
                      placeholder="What best describes you?"
                      onChange={(selectedOption) => {
                        setData({
                          ...data,
                          whatBestDescribesYou: selectedOption
                        })
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          fontSize: '14px',
                        }),
                        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                          return {
                            ...styles,
                            fontSize: '14px',
                          };
                        },
                      }}
			        />
                  </div>
            }

            {
              isPartner ?
                <>
                  <div>
                    <label htmlFor="noOfEmployees" className="sr-only">
                      No of Payrolls
                    </label>

                    <Select
			          options={
                        noOfPayrollsOptions
                      }
                      placeholder="No of Payrolls"
                      onChange={(selectedOption) => {
                        setData({
                          ...data,
                          noOfPayrolls: selectedOption
                        })
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          fontSize: '14px',
                        }),
                        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                          return {
                            ...styles,
                            fontSize: '14px',
                          };
                        },
                      }}
			        />
                  </div>

                  <div>
                    <label htmlFor="noOfEmployees" className="sr-only">
                      No of Employees
                    </label>
                    <Select
			          options={
                        noOfEmployeesOptions[jurisdiction]
                      }
                      placeholder="No of Employees"
                      onChange={(selectedOption) => {
                        setData({
                          ...data,
                          noOfEmployees: selectedOption
                        })
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          fontSize: '14px',
                        }),
                        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                          return {
                            ...styles,
                            fontSize: '14px',
                          };
                        },
                      }}
			        />
                  </div>

                  <div className="relative">
                    <label htmlFor="noOfEmployees" className="sr-only text-xs absolute -top-4">
                      Current Payroll Software
                    </label>
                    <Creatable
			          options={payrollSofwareOptions[jurisdiction].map((option) => {
                          return { value: option, label: option }
                      })}
                      isMulti={true}
                      isClearable={true}
                      onChange={(selectedOption) => {
                        setData({
                          ...data,
                          payrollSoftware: selectedOption
                        })
                      }}
                      formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                      placeholder="What Software do you use? (Choose or type)"
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          fontSize: '14px',
                        }),
                        // also adjust size of options
                        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                          return {
                            ...styles,
                            fontSize: '14px',
                          };
                        },

                      }}
			        />
                  </div>



                </>
                  :
                  <div>
                    <label htmlFor="noOfEmployees" className="sr-only">
                      No of Employees
                    </label>
                    <div className="rounded-md shadow-sm">
                      <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                        <option>How many Employees do you have?</option>
                        <option value="1-5">1-5 Employees</option>
                        <option value="6-10">6-10 Employees</option>
                        <option value="11-20">11-20 Employees</option>
                        <option value="21-40">21-40 Employees</option>
                        <option value="41-80">41-80 Employees</option>
                        <option value="81-200">81-200 Employees</option>
                        <option value="200+">200+ Employees</option>
                      </select>
                    </div>
                  </div>
            }

            <div>
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <div className="relative rounded-md shadow-sm">
                <input
                  value={data.email}
                  onChange={handleChange}
                  name="email"
                  id="email"
                  placeholder="Email"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  aria-invalid="true"
                  aria-describedby="email-error"
                />
              {  !isEmailValid &&
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                </div>
              }
            </div>
            </div>
            {!shouldUseLeadForm &&
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.password} onChange={handleChange} autoComplete="off" name="password" id="password" type="password" placeholder="Password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
                {/*<p className="mt-2 text-sm text-red-600" id="email-error">
                  {errorText}
                </p>*/}
              </div>
            }

            {/*
                passwordValidation && passwordValidation.length > 0 && passwordValidation[0] != "notEqual" &&
                <div className="col-xs-12 alert-danger alert">
                  <h5 style={{
                    textAlign: "left",

                  }}>Your password must have at least.</h5>
                  <ul style={{
              listStyle: "disc",
              paddingLeft: "20px",
              textAlign: "left",
                  }}>
                    <li>8 characters long</li>
            <li>1 uppercase &amp; 1 lowercase character</li>
            <li>1 number</li>
                  </ul>
                </div>
            */}

            <div>
              <span className="block w-full rounded-md shadow-sm">
                <button
                  type="submit"
                  disabled={shouldUseLeadForm && savingLead}
                  className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out"
                >
                  {shouldUseLeadForm ? (savingLead ? "Submitting..." : (leadCtaText || "Request a demo")) : "Create a FREE DEMO Account"}
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
      </div>
    </div>


  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const createAccount = state && state.createAccount
  let profile = state && state.my && state.my.profile

  if (!profile){
    // check if we have url params in the request
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    const givenName = urlParams.get('givenName');
    const familyName = urlParams.get('familyName');
    const organisation = urlParams.get('name');
    profile = {
      isPreloaded: true,
      email,
      givenName,
      familyName,
      organisation
    }
  }

  return {
    creatingAccount: createAccount.creating,
    error: createAccount.error,
    userCreated: createAccount.userCreated,
    userUpdated: createAccount.userUpdated,
    acLeadCreated: createAccount.acLeadCreated,
    demoAccountCreated: createAccount.demoAccountCreated,
    savedLead: createAccount.savedLead,
    savingLead: createAccount.savingLead,
    profile,
    processing: state.authentication.processing,
  }
}

const mapDispatchToProps = dispatch => ({
  createAccount: (data) => dispatch(CREATEACCOUNTACTIONS.createAccount(data)),
  updateUserDetails: (data) => dispatch(CREATEACCOUNTACTIONS.updateUserDetails(data)),
  saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
  logout: () => dispatch(LOGINACTIONS.logout()),
  createHandoffCode: (portal) => dispatch(LOGINACTIONS.createHandoffCode(portal)),
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationForm)
